import React from 'react'
import { SiteNavbar } from '@/components/frontend/organisms/SiteNavbar'
import { SiteFooter } from '@/components/frontend/organisms/SiteFooter'
import { PageShell, PageMain } from '@/components/frontend/atoms/layout/PageShell'

interface PublicLayoutProps {
  children: React.ReactNode
}

export const PublicLayout: React.FC<PublicLayoutProps> = ({ children }) => (
  <PageShell>
    <SiteNavbar />
    <PageMain>{children}</PageMain>
    <SiteFooter />
  </PageShell>
)
